import script from "./CustomerProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerProducts.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerProducts.vue?vue&type=style&index=0&id=38dd730d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38dd730d"]])

export default __exports__